import React, { useState, useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Add as AddIcon } from '@material-ui/icons';
import { useParams } from 'react-router';
import * as yup from 'yup';

import {
  Button,
  ReactFormInput,
  FormInputHidden,
  ReactHookFormModal,
} from '../../../../components';
import { useActionDispatcher } from '../../../../hooks';
import { selectListScenes } from '../../../../store/modules/scenes/selectors';
import { createScenesRequest } from '../../../../store/modules/scenes/actions';
import useStyles from '../styles';

const sceneSchema = yup.object().shape({
  title: yup.string().required().trim(),
});

const AddScriptAction = () => {
  const classes = useStyles();
  const scenesList = useSelector(selectListScenes);
  const { id: projectId } = useParams<{id: string}>();
  const [open, setOpen] = useState(false);
  const createScene = useActionDispatcher(createScenesRequest);
  const scenes = scenesList.data?.items;
  const { loading } = scenesList;
  const scenesTotal = scenesList.data?.pagination.totalItems || 1;

  const initialValues = useMemo(() => ({
    title: '',
    sequence_order: scenesTotal,
    project_id: parseInt(projectId, 10),
  }), [scenesTotal, projectId]);

  useEffect(() => {
    setOpen(false);
  }, [scenes, setOpen]);

  return (
    <>
      {open && (
        <ReactHookFormModal
          open={open}
          title="Create Script"
          onCloseHandler={() => setOpen(false)}
          formSettings={{
            initialValues,
            validationSchema: sceneSchema,
            onSubmit: createScene,
            creatingMode: true,
            loading,
          }}
        >
          <>
            <ReactFormInput autoFocus name="title" label="Title" />
            <FormInputHidden name="project_id" />
            <FormInputHidden name="sequence_order" />
          </>
        </ReactHookFormModal>
      )}
      <Button
        variant="outlined"
        disabled={scenesList.loading}
        classes={{
          label: classes.labelAddScene,
          root: classes.buttonAddScene,
        }}
        onClick={() => setOpen(true)}
      >
        <AddIcon />
        Add Script
      </Button>
    </>
  );
};

export default AddScriptAction;
